<div class="container mt-4">
   <div class="d-flex align-items-center justify-content-between mb-3">
      <button type="button" class="btn btn-link px-0" (click)="goBackToSearch()">&larr; Back to Search</button>

      <div class="btn-group" role="group" aria-label="Subscription sections">
         <button type="button"
                 class="btn"
                 [class.btn-site-secondary]="activePanel() === 'billing'"
                 [class.btn-site-outline-secondary]="activePanel() !== 'billing'"
                 (click)="togglePanel('billing')">
            Billing
         </button>
         <button type="button"
                 class="btn"
                 [class.btn-site-secondary]="activePanel() === 'membership'"
                 [class.btn-site-outline-secondary]="activePanel() !== 'membership'"
                 (click)="togglePanel('membership')">
            Membership
         </button>
      </div>
   </div>

   <div class="card">
      <div class="card-body">
         <h5 class="card-title">Account Detail</h5>
         <!--<p class="card-text">Account ID: <strong>{{ accountSafeId() }}</strong></p>-->

         @if (accountIsLoading()) {
         <div class="d-flex justify-content-center my-3">
            <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
               <span class="visually-hidden">Loading...</span>
            </div>
         </div>
         } @else if (accountErrorMessage()) {
         <div class="alert alert-danger my-3" role="alert">
            <strong>Unable to load account detail.</strong>
            <div class="small">{{ accountErrorMessage() }}</div>
         </div>
         } @else {
         <!-- can't use "as" syntax in "else if" block - only allowed in an "if" block'-->
         @if (actionableSubscription(); as sub) {
         <app-account-card [actionableSubscription]="sub" />
         }
         }
      </div>
   </div>

   @if (activePanel() === 'membership') {
      @if (actionableSubscription(); as sub) {
      <app-subscription-membership [subscription]="sub" />
      }
   } @else if (activePanel() === 'billing') {
   <app-subscription-billing [accountSafeId]="accountSafeId()" />
   }
</div>
